import React, { PropTypes } from 'react';
import { reduxForm, Field, initialize, SubmissionError, reset } from 'redux-form';
import RenderField from '../../../../FormTemplate/InputControl';
import { Button } from 'react-bootstrap';
import axios from './../../../../../constants/axios';
import alert from 'alertify.js';

@reduxForm({
   form: 'productMainEditPriceForm'
})
class ProductMainEditPriceForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         productName: ''
      };
   }

   componentDidMount() {
      const { productId } = this.props.params;
      return axios
         .get(`items/productMain/getPriceById/${productId}`)
         .then((res) => {
            this.props.dispatch(initialize('productMainEditPriceForm', res.data, true));
            this.setState({
               productName: res.data.name
            });
         });
   }

   updatePrice = (price) => {
      const { productId } = this.props.params;
      const data = Object.assign({}, price, {
         id: productId
      });
      return axios.post('items/productMain/updatePrice', data)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Product Updated.');
               this.props.dispatch(initialize('productMainEditPriceForm', data, true));
               this.props.dispatch(reset('productMainEditPriceForm'));
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, pristine, invalid } = this.props;
      const { productName } = this.state;
      return (
         <div>
            <h3>Product Name: {productName}</h3>
            <hr/>
            <form noValidate autoComplete="off" onSubmit={handleSubmit(this.updatePrice)} >
               <Field name="price" component={RenderField} type="number" label="Price" />
               <Field name="discount" component={RenderField} type="number" label="Discount" />

               <Button type="submit" bsStyle="success" block
                       disabled={submitting || pristine || invalid} >Update</Button>
            </form>
         </div>
      );
   }
}

ProductMainEditPriceForm.propTypes = {
   handleSubmit: PropTypes.func,
   params: PropTypes.object,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   dispatch: PropTypes.func
};

export default ProductMainEditPriceForm;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainEditPriceForm.js
 **/